export default {
  showFooter: true,
  isSidebarCompact: false,
  showBreadcrumb: false,
  menuAutoCollapsed: true,
  mode: 'light',
  layout: 'mix',
  splitMenu: true,
  sideMode: 'light',
  isFooterAside: false,
  isSidebarFixed: true,
  isHeaderFixed: true,
  isUseTabsRouter: true,
  showHeader: true,
  brandTheme: '#0052D9',
}
